const statusTooltipText = {
  RECSTATUS_RECRUITING: 'The study is currently recruiting participants.',
  RECSTATUS_I_NOT_YET_REC:
    'The study has not yet started recruiting participants.',
  RECSTATUS_I_ACTIVE_NOT_REC:
    'The study is ongoing, and participants are receiving an intervention or being examined, but potential participants are not currently being recruited or enrolled.',
  RECSTATUS_I_COMPLETED:
    "The study has ended normally, and participants are no longer being examined or treated (that is, the last participant's last visit has occurred).",
  RECSTATUS_I_TERMINATED_HALT_P:
    'The study has stopped early and will not start again. Participants are no longer being examined or treated.',
  RECSTATUS_I_WITHDRAWN:
    'The study stopped early, before enrolling its first participant.',
  RECSTATUS_I_SUSPENDED:
    'Study has been paused temporarily and may resume later.',
  RECSTATUS_O_ONGOING:
    'Study is actively being conducted; data collection, analysis, or other activities are in progress.',
  RECSTATUS_O_PLANNED:
    'Study is in the preparatory phase; activities have not yet commenced.',
  RECSTATUS_O_COMPLETED:
    'Study has been completed and the final results are available or reported.',
  RECSTATUS_O_DISCONTINUED:
    'Study was started but terminated before completion.',
  RECSTATUS_O_SUSPENDED:
    'Study has been paused temporarily and may resume later.',
  RECSTATUS_O_CANCELLED:
    'Study was planned but cancelled before it began.',
  RECSTATUS_EA_AVAILABLE: 'Expanded access is currently available.',
  RECSTATUS_EA_NO_LONGER_AVAILABLE:
    'Expanded access was available previously but is not currently available and is not expected to be available in the future.',
  RECSTATUS_NOT_YET_RECRUITING:
    'The study has not yet started recruiting participants.',
  RECSTATUS_NOT_RECRUITING:
    'The study is ongoing, and participants are receiving an intervention or being examined, but potential participants are not currently being recruited or enrolled.',
  RECSTATUS_STUDY_COMPLETED:
    "The study has ended normally, and participants are no longer being examined or treated (that is, the last participant's last visit has occurred).",
  RECSTATUS_COMPLETED:
    "The study has ended normally, and participants are no longer being examined or treated (that is, the last participant's last visit has occurred).",
  RECSTATUS_SUSPENDED:
    'Study has been paused temporarily and may resume later.',
  RECSTATUS_TERMINATED: 'Study was started but terminated before completion.',
  RECSTATUS_OTHER:
    'This study has a status that does not fall into the standard categories.',
  RECSTATUS_RELIQUISHED: 'This study is no longer a ViiV study.',
};

export const getStudyStatusTooltipText = (statusInternal) =>
  statusTooltipText[statusInternal] || null;
